
.stickyPagination {
  min-height: 2rem;
  background: var(--static-background-weak);
  padding: 10px;
  border-top: 1px solid var(--static-divider-standard);
  position: static;
  bottom: 0;
  flex-shrink: 0;
}
.pageButton {
  padding: 0 0.5rem !important;
}
.pageNumber {
  min-width: 1em;
  text-align: center;
}
